// extracted by mini-css-extract-plugin
export var deleteModal = "_hw-0";